export default function Section(props) {
    return (
        <section className={props.className}>
            <div className="container mx-auto">{props.children}</div>
        </section>
    );
}
